module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Food/Bread-96482814a28233824c2067d7c69a9b23.svg";